import React from 'react';
import * as S from '../ListingSection/listing-section.styles';

const NoDestinationFound = ({ source, destination }) => {
  return (
    <S.ListingOuter
      className="errorState dF flexCol justifyCenter alignItemsCenter"
      style={{ height: '80vh' }}
    >
      <p className="marginB20">
        <img src={'https://gos3.ibcdn.com/emptyState-1656584030.png'} width="188" height="83" />
      </p>
      <div className="fb quicksand font22 marginB10">
        No destinations found for this trip {source?.ct} - {destination?.ct || destination?.cnty}
      </div>
    </S.ListingOuter>
  );
};
export default NoDestinationFound;
